import React, { useEffect, useState } from "react";
import { Box, FormControl, Select } from "@primer/react";
import Modal from "../../components/ui/modal";
import ModalActions from "../../components/ui/modal/ModalActions";
import Button from "../../components/ui/button";
import ComboboxLopMonHoc from "../../components/combobox-lop-monhoc";
import ComboBoxGiaoVien from "../../components/combobox-giaovien";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";

type Props = {
    lopId: number;
    subjects: { id: number; name: string; sis_giaovien_id: number }[];
    selectedSubjects: { id: number; name: string; sis_giaovien_id: number }[];
    onClose: () => void;
    onSubmit: (data: any) => void;
};

const SelectSubjectModal = ({ subjects, selectedSubjects, lopId, onClose, onSubmit }: Props) => {
    const [selectedId, setSelectedId] = useState(0);
    const [selectedTeacherId, setSelectedTeacherId] = useState(0);
    const [selectedTeacherName, setSelectedTeacherName] = useState("");
    const [selectedSubjectName, setSelectedSubjectName] = useState("");
    const { dm_truong_id } = useCommonSelectedHook();

    const handleSubmit = () => {
        if (!selectedId || !selectedTeacherId) return;

        onSubmit({
            id: selectedId,
            name: `${selectedSubjectName} (${selectedTeacherName})`,
            sis_giaovien_id: selectedTeacherId
        });
    };

    useEffect(() => {
        setSelectedId(0);
    }, [lopId]);

    return (
        <Modal
            isOpen
            onClose={onClose}
            width="small"
            title="Chọn bộ môn"
        >
            <Box sx={{ display: "grid", gap: 2 }}>
                <FormControl>
                    <FormControl.Label>Lớp bộ môn</FormControl.Label>
                    <ComboboxLopMonHoc
                        lopId={lopId}
                        selectedSubjects={selectedSubjects}
                        value={selectedId}
                        onValueChanged={(id, data) => {
                            setSelectedId(id);
                            setSelectedSubjectName(data?.name ?? "");
                        }}
                    />
                </FormControl>
                <FormControl>
                    <FormControl.Label>Giáo viên</FormControl.Label>
                    <ComboBoxGiaoVien
                        variant='invisible'
                        dm_truong_id={dm_truong_id}
                        value={selectedTeacherId}
                        onValueChanged={(id, data) => {
                            setSelectedTeacherId(id)
                            setSelectedTeacherName(data?.ho_ten ?? "")
                        }}
                    />
                </FormControl>
            </Box>

            <ModalActions>
                <Button text="Đóng" onClick={onClose} />
                <Button
                    text="Chọn"
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={!selectedId || !selectedTeacherId}
                />
            </ModalActions>
        </Modal>
    );
};

export default SelectSubjectModal;